import React, { useState } from 'react';
import { auth, db } from '../firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userDocRef = doc(db, 'users', user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        if (userData.isAdmin) {
          onLoginSuccess(user);
        } else {
          setError('Access Denied: You are not authorized.');
          await auth.signOut();
        }
      } else {
        setError('User profile not found.');
        await auth.signOut();
      }
    } catch (err) {
      let errorMessage = 'Login failed. Please check your credentials.';
      if (err.code === 'auth/invalid-credential') errorMessage = 'Invalid email or password.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Responsive Injection: This allows us to handle mobile screens without a separate file */}
      <style>
        {`
          @media (max-width: 480px) {
            .login-box { width: 90% !important; padding: 20px !important; }
            .title { font-size: 20px !important; }
          }
        `}
      </style>

      <div style={styles.loginBox} className="login-box">
        {/* Header Section */}
        <div style={styles.header}>
          <div style={styles.logoCircle}>
            <img 
              src="/appicon.png" 
              alt="App Logo" 
              style={styles.logoImg} 
            />
          </div>
          <h2 style={styles.title} className="title">Find My Room</h2>
          <p style={styles.subtitle}>Admin Portal</p>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
          
          {error && <p style={styles.errorText}>{error}</p>}
          
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Authenticating...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f4f7f6',
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  loginBox: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    width: '350px',
    transition: 'all 0.3s ease',
  },
  header: {
    marginBottom: '30px',
  },
  logoCircle: {
    width: '60px',
    height: '60px',
    backgroundColor: '#ffffff',
    border: '1px solid #00315e',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    margin: '0 auto 15px auto',
    overflow: 'hidden',
    padding: '3px',
  },

  logoImg: {
    width: '110%',
    height: '110%',
    objectFit: 'contain',
    
  },
  title: {
    margin: '0 0 5px 0',
    color: '#1a202c',
    fontSize: '24px',
  },
  subtitle: {
    margin: 0,
    color: '#718096',
    fontSize: '14px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  input: {
    padding: '14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '16px',
    backgroundColor: '#f9fafb',
    outline: 'none',
  },
  button: {
    padding: '14px',
    backgroundColor: '#00315e',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  errorText: {
    color: '#e53e3e',
    fontSize: '13px',
    margin: '-5px 0 0 0',
  },
};

export default LoginPage;